import React, { createContext, useContext, useState } from "react";

const RfcLibraryContext = createContext();

export const useRfcLibrary = () => useContext(RfcLibraryContext);

export const RfcLibraryProvider = ({ children }) => {
    const [fileList, setFileList] = useState([]);

    return (
        <RfcLibraryContext.Provider value={{ fileList, setFileList }}>
            {children}
        </RfcLibraryContext.Provider>
    );
};
